module.exports = __webpack_public_path__ + "img/icon-check-white.9bb87eeb.svg";